export const ROLE_ENJOY = "ROLE_ENJOY"
export const ROLE_ADMIN = "ROLE_ADMIN"
export const ROLE_CODIR = "ROLE_CODIR"
export const ROLE_AMBASSADOR = "ROLE_AMBASSADOR"
export const ROLE_USER = "ROLE_USER"
export const ROLE_SPONSOR = "ROLE_SPONSOR"

export const IS_SUPER_HEAD = (roles) => roles.includes(ROLE_AMBASSADOR) ||  roles.includes(ROLE_ENJOY)
export const IS_HEAD = (roles) => IS_SUPER_HEAD(roles) || roles.includes(ROLE_CODIR)
export const IS_PILOT = (currentUserId, pilotId) => currentUserId === pilotId
export const IS_COPILOT = (currentUserId, copilot) => copilot ? currentUserId === copilot.id : false
export const IS_MEMBER  = (currentUserId, members) => members.map(m => m.id).includes(currentUserId)
export const IS_SPONSOR  = (currentUserId, sponsor) => sponsor ? currentUserId === sponsor.id : false